import React, { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";
import { Button } from "reactstrap";
import SupportForm from "./SupportForm";
import { optionsEnum, getBrowserLocale } from "../Utils/SupportUtils";
import Card from "../components/Card";

const messages = defineMessages({
  chooseContact: {
    id: "Contact.chooseContact",
    defaultMessage: "Choose a contact option.",
  },
  email: {
    id: "Contact.email",
    defaultMessage: "Email",
  },
  phone: {
    id: "Contact.phone",
    defaultMessage: "Phone",
  },
  contactChoice: {
    id: "Contact.contactChoice",
    defaultMessage: "How would you want to be contacted?",
  },
  backButton: {
    id: "Contact.backButton",
    defaultMessage: "Back",
  },
  selectedInformation: {
    id: "Contact.selectedInformation",
    defaultMessage: "You are searching information for:",
  },
});

class Contact extends Component {
  state = {
    contactOption: null,
  };

  toggleForm = (option) => {
    this.setState({
      ...this.state,
      contactOption: option,
    });
    this.props.saveContactOption(option);
  };

  render() {
    const {
      onSubmit,
      sendSupportDataError,
      styles,
      saveNodeData,
      historyNodes,
      intl: { formatMessage },
    } = this.props;
    const { contactOption } = this.state;

    const emailNode = {
      imgname:
        styles && styles.emailIconName
          ? styles.emailIconName
          : "fas fa-envelope",
      text: formatMessage(messages.email),
    };
    const phoneNode = {
      imgname:
        styles && styles.phoneIconName ? styles.phoneIconName : "fas fa-phone",
      text: formatMessage(messages.phone),
    };

    const bbStyles = styles.backButtonStyle
      ? {
          backgroundColor: styles.backButtonStyle.backgroundColor,
          border: `1px solid ${styles.backButtonStyle.borderColor}`,
          color: styles.backButtonStyle.color,
        }
      : {};

    const language = getBrowserLocale();

    return (
      <div className="container-md pt-5">
        {!contactOption && (
          <>
            <div
              className="text-left mb-4"
              style={{ color: styles.bodyStyle.color }}
            >
              <Button style={bbStyles} onClick={() => saveNodeData()}>
                {formatMessage(messages.backButton)}
              </Button>
            </div>
            <div
              className="text-center mb-4"
              style={{ color: styles.bodyStyle.color, fontFamily: "Fresca" }}
            >
              <p style={{ fontSize: "1.5em", margin: "0" }}>
                {formatMessage(messages.selectedInformation)}
              </p>
              {historyNodes.map((el, index) => {
                return (
                  <span key={el.nodeid}>
                    {el.label[language]}
                    {index < historyNodes.length - 1 && " > "}
                  </span>
                );
              })}
            </div>
            <h2
              className="text-center"
              style={{ color: styles.bodyStyle.color, fontWeight: 300 }}
            >
              {formatMessage(messages.contactChoice)}
            </h2>

            <div className="row justify-content-center">
              <Card
                node={phoneNode}
                iconStyle={styles.iconStyle}
                bodyStyle={styles.bodyStyle}
                selectHandler={() => this.toggleForm(optionsEnum.PHONE)}
                className="col-md-3 col-sm-4 m-4"
                contactOption={true}
              />
              <Card
                node={emailNode}
                iconStyle={styles.iconStyle}
                bodyStyle={styles.bodyStyle}
                selectHandler={() => this.toggleForm(optionsEnum.EMAIL)}
                className="col-md-3 col-sm-4 m-4"
                contactOption={true}
              />
            </div>
          </>
        )}
        {contactOption && (
          <SupportForm
            contactOption={contactOption}
            onSubmit={onSubmit}
            sendSupportDataError={sendSupportDataError}
            toggleForm={this.toggleForm}
            submitButtonStyles={styles.submitButtonStyle}
            backButtonStyles={styles.backButtonStyle}
            bodyStyle={styles.bodyStyle}
            errorMessage={styles.errorMessage}
            historyNodes={historyNodes}
          />
        )}
      </div>
    );
  }
}

export default injectIntl(Contact);
